function hoursToMillis() {

  let hoursToMillisDirective = {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      function toMillis(hours) {
        console.log("%o", ngModel );
        return hours * 3600 * Math.pow(10,3);
      }

      function toHours(millis) {
        console.log("%o", ngModel );
        return Math.floor(millis / (3600 * Math.pow(10,3)));
      }

      ngModel.$parsers.push(toMillis);
      ngModel.$formatters.push(toHours);
    }
  };

  return hoursToMillisDirective;

}

export default hoursToMillis;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/activationHourServices/hoursToMillis.js
 **/